
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/layout/Header";
import TabMenu from "../components/navigation/TabMenu";
import TabNavigation from "../components/navigation/TabNavigation";
import ResourceGrid from "../components/resources/ResourceGrid";
import TabContent from "../components/tabs/TabContent";

const Index = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("integrations");
  const [showTabsNav, setShowTabsNav] = useState(true);
  const [mainView, setMainView] = useState(true);

  const tabMap: Record<string, string> = {
    "integrations": "integrations",
    "alerts": "alerts",
    "presets": "presets",
    "standards": "standards",
    "bpa": "bpa",
    "licenses": "licenses"
  };

  const tabContent: Record<string, { title: string; description: string }> = {
    "integrations": {
      title: "CIPP Integrations",
      description: "Connect your CIPP instance with other tools and services"
    },
    "alerts": {
      title: "Security Alerts",
      description: "Configurable security notifications for your environment"
    },
    "presets": {
      title: "Graph API Presets",
      description: "Ready-to-use Graph API queries for common data needs"
    },
    "standards": {
      title: "Security Standards",
      description: "Industry security standards and best practices implementations"
    },
    "bpa": {
      title: "BPA Templates",
      description: "Best Practice Assessment templates for environment evaluation"
    },
    "licenses": {
      title: "License Helper",
      description: "Search and explore Microsoft 365 licenses and service plans"
    }
  };

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    
    if (tabParam && tabMap[tabParam]) {
      setActiveTab(tabMap[tabParam]);
      setShowTabsNav(false);
      setMainView(false);
    } else {
      setShowTabsNav(true);
      setMainView(true);
    }
  }, [searchParams]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
    setMainView(false);
  };

  const handleCardClick = (id: string) => {
    handleTabChange(id);
  };

  const handleBackToMainView = () => {
    setSearchParams({});
    setMainView(true);
  };

  const tabMenuItems = Object.keys(tabMap).map(key => ({
    id: tabMap[key],
    title: tabContent[tabMap[key]].title
  }));

  const currentTabContent = tabContent[activeTab] || tabContent["integrations"];
  const pageTitle = mainView ? "CyberDrain Resources" : currentTabContent.title;
  const pageDescription = mainView 
    ? "Explore integrations and functionality available to enhance your CIPP experience" 
    : currentTabContent.description;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-black text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="flex justify-between items-center mb-6 w-full">
          <Header 
            title={pageTitle}
            description={pageDescription}
            mainView={mainView}
          />
          
          {!showTabsNav && (
            <TabMenu
              tabItems={tabMenuItems}
              activeTab={activeTab}
              onTabChange={handleTabChange}
              onBackToMainView={handleBackToMainView}
            />
          )}
        </div>

        {mainView ? (
          <ResourceGrid onCardClick={handleCardClick} />
        ) : showTabsNav ? (
          <TabNavigation activeTab={activeTab} onTabChange={handleTabChange} />
        ) : (
          <div className="mb-8">
            <TabContent tabName={activeTab} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
